import styled from 'styled-components';

export const FilterStyles = styled.div`
  font-family: var(--font-family);

  .search-card {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 176px);
    padding: 12px 18px 0;
  }

  .search-title {
    display: flex;
    align-items: baseline;
    gap: 14px;
    flex-wrap: wrap;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #dee2e6;

    h3 {
      color: #354985;
      font-size: 1.15rem;
      font-weight: 600;
    }
  }

  .search-hint {
    color: #8a94a6;
    font-size: 0.8rem;
  }

  .search-card.is-inline {
    min-height: 0;
  }

  .search-grid {
    flex: 1;
    align-content: start;
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
  }

  @media (min-width: 992px) {
    .search-grid {
      grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr);
      align-items: stretch;
    }

    .search-col > .sec:last-child {
      flex: 1;
    }
  }

  @media (min-width: 1100px) {
    .search-grid.is-row {
      grid-template-columns: minmax(0, 1.7fr) minmax(0, 1fr) minmax(0, 1.25fr);
      align-items: stretch;

      .sec {
        flex: 1;
      }
    }
  }

  .search-col {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 0;
  }

  .sec {
    padding: 8px 12px 10px;
    border: 1px solid #e3e7ee;
    border-radius: 8px;
    background: #fbfcfe;
    display: flex;
    flex-direction: column;
    gap: 6px;

    h4 {
      display: flex;
      align-items: center;
      gap: 7px;
      color: #354985;
      font-size: 0.72rem;
      font-weight: 700;
      letter-spacing: 0.08em;
      text-transform: uppercase;

      svg {
        width: 15px;
        height: 15px;
      }
    }
  }

  .row {
    display: grid;
    gap: 10px;
    grid-template-columns: minmax(0, 1fr);
  }

  @media (min-width: 640px) {
    .row.r2 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .row.r3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .row.r4 {
      grid-template-columns: minmax(0, 1.25fr) minmax(0, 1.25fr) minmax(0, 1fr) minmax(0, 0.8fr);
    }
  }

  .field-box {
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 0;

    label {
      overflow: hidden;
      color: #6c757d;
      font-size: 0.78rem;
      font-weight: 500;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .p-inputtext,
  .p-dropdown .p-dropdown-label.p-inputtext {
    padding: 0.42rem 0.65rem;
    font-family: var(--font-family);
    font-size: 0.875rem;
  }

  .p-inputtext,
  .p-dropdown {
    width: 100%;
  }

  .p-dropdown .p-dropdown-trigger {
    width: 2rem;
  }

  .date-input {
    position: relative;

    &.is-active .p-inputmask {
      border-color: #354985;
      box-shadow: 0 0 0 3px rgba(53, 73, 133, 0.22);
    }

    .p-inputmask {
      padding-right: 2.2rem;
    }
  }

  .date-inputs .p-calendar {
    position: relative;
    display: block;

    .p-inputtext {
      padding-right: 2.2rem;
      border-radius: 6px;
    }

    .p-datepicker-trigger {
      position: absolute;
      top: 50%;
      right: 4px;
      width: 26px;
      height: 26px;
      border: 0;
      border-radius: 6px;
      background: transparent;
      color: #8a94a6;
      transform: translateY(-50%);

      &:enabled:hover,
      &:focus-visible {
        background: #eef1f8;
        color: #354985;
      }
    }
  }

  .date-trigger {
    position: absolute;
    top: 50%;
    right: 4px;
    width: 26px;
    height: 26px;
    display: grid;
    place-items: center;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: #8a94a6;
    cursor: pointer;
    transform: translateY(-50%);

    svg {
      width: 15px;
      height: 15px;
    }

    &:hover,
    &:focus-visible {
      background: #eef1f8;
      color: #354985;
    }
  }

  .date-filter {
    display: flex;
    flex-direction: column;
    gap: 4px;

    & + .date-filter {
      padding-top: 8px;
      border-top: 1px dashed #dde2ea;
    }
  }

  .date-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-height: 28px;
  }

  .date-label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #495057;
    font-size: 0.85rem;
    font-weight: 500;
  }

  .date-info {
    width: 14px;
    height: 14px;
    color: #8a94a6;
    cursor: help;
  }

  .date-inputs {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
    align-items: center;
    gap: 8px;
  }

  .date-to {
    color: #8a94a6;
    font-size: 0.78rem;
  }

  .p-selectbutton .p-button {
    padding: 0.28rem 0.7rem;
    font-family: var(--font-family);
    font-size: 0.78rem;
  }

  .status-buttons {
    display: flex;
    flex-wrap: wrap;

    .p-button {
      padding: 0.4rem 0.55rem;
      font-size: 0.8rem;
      white-space: nowrap;
    }
  }

  .idle-filters {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding-top: 6px;
    border-top: 1px dashed #dde2ea;

    label {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px;
      color: #495057;
      font-size: 0.85rem;
    }

    .p-inputnumber input {
      width: 3.6rem;
      padding: 0.3rem 0.4rem;
      text-align: center;
    }

    small {
      color: #8a94a6;
      font-size: 0.75rem;
    }
  }

  .search-actions {
    position: sticky;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    margin: 10px -18px 0;
    padding: 8px 18px;
    border-top: 1px solid #dee2e6;
    border-radius: 0 0 6px 6px;
    background: #fff;

    .buttons {
      display: flex;
      gap: 8px;
    }

    .p-button {
      height: 36px;
      font-family: var(--font-family);
      font-size: 0.875rem;
    }
  }

  .active-count {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #6c757d;
    font-size: 0.82rem;

    svg {
      width: 14px;
      height: 14px;
      color: #354985;
    }
  }
`;
